import React from 'react';
import {Typography} from 'antd';

import useStyles from './Logo.styles';

const {Text} = Typography;

const Logo: React.FC = () => {
	const classes = useStyles();
	return (
		<div className={classes.logo}>
			<Text italic>Canvas Demo</Text>
		</div>
	);
};

export default Logo;
